module.exports = __webpack_public_path__ + "static/media/pb5.e8171283.png";